import { SET_OPTIONS_START, SET_OPTIONS } from '../actions';

const initialState = {
    fetched: false,
    failed: false,
    data: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_OPTIONS_START:
            return { ...state, fetched: false, options: [] };
        case SET_OPTIONS:
            return {
                ...state,
                fetched: true,
                data: action.payload,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/options_reducer.jsx